export class ObjectHelper {
    static keyExists(o:any, k:string): boolean {
        let found = false;
        for (const i of Object.keys(o)) {
            if(i == k) {
                found = true;
            }
            if (!found && !!o[i] && typeof(o[i]) === 'object') {
                found = this.keyExists(o[i], k);
            }
        }
        return found;
    }
    static empty(v:any) {
        if(v === null) return true;
        if(v === undefined) return true;
        if(v === '') return true;
    }
    static equal<T1, T2>(o1:T1, o2:T2): boolean {
        const a = JSON.stringify(this.sortObject(o1));
        const b = JSON.stringify(this.sortObject(o2));
        return a === b;
    }
    static sortObject<T>(o: T): T {
        if(typeof o === 'object' && !ObjectHelper.empty(o)) {
            Object.entries(o)
                .sort(([k1, ], [k2, ]) => +k2 - +k1)
                .reduce((r, [k, v]) => ({ ...r, [k]: this.sortObject(v) }), {});
        }
        return o;
    }
}
